var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.src)?_c('img',{attrs:{"width":"60","src":require("../../assets/icons/picture.png"),"alt":""}}):_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.src,"alt":_vm.file.filename}})])}
var staticRenderFns = []

export { render, staticRenderFns }